import React, { useContext, useEffect } from 'react';
import { LocalizationContext } from '../../../context/LangChange';
import img from '../../../assets/Img';
import { Col, Row } from 'react-bootstrap';
import ServicesSlider from '../ServicesSlider';
import '../seo.css'
import '../Service/scervice.scss';

import ServicesGrid from './ServicesGrid';
import WhyChooseRightClick from './WhyChooseRightClick';
import Component from '../../../constants/Component';
const translations = {
  en: require('../../../Translate/en.json').Branding,
  ar: require('../../../Translate/ar.json').Branding,
};

const SeoBranding = () => {
  const { isLang } = useContext(LocalizationContext);
  const t = translations[isLang || 'en'];

  const data = {
    title: t.title,
    dec: t.dec,
    img: img.Branding,
    title2: t.title2,
    dec2: t.dec2,
  };
 useEffect(() => { 
    window.scroll(0, 0)  
  }, [])

  return (
    <div className="app_brand overflow-hidden">
      <div className="slider">
        <ServicesSlider data={data} />
        <div className="who-we-are-container">
          <div className="who-we-are-content">
            <h2 className="who-we-are-title">{t.who_we_are_title}</h2>
            <p className="who-we-are-description">{t.who_we_are_description}</p>
          </div>
        </div>
      </div>

      <div className="services-section">
        <Row gutter={[32, 32]} align="middle">
          <Col xs={12} sm={12} md={6}>
            <img
              src={img.Branding1}
              alt="Brand Positioning"
              width="100%"
              className="service-image"
            />
          </Col>

          <Col xs={12} sm={12} md={6}>

            <Row gutter={[32, 32]}>
              <Col xs={12} className={`  ${isLang == "en" ? "ltr" : "rtl"}`}> 
                <h2 className="section-title">{t.BrandPositioning.title}</h2>
                <ul className={`service-list`}> 
                  <li><strong>{t.BrandPositioning.uniqueMarketSpace}:</strong> {t.BrandPositioning.uniqueMarketSpaceDesc}</li>
                  <li><strong>{t.BrandPositioning.highlightStrengths}:</strong> {t.BrandPositioning.highlightStrengthsDesc}</li>
                  <li><strong>{t.BrandPositioning.connectAudiences}:</strong> {t.BrandPositioning.connectAudiencesDesc}</li>
                </ul>
              </Col>

              <Col xs={12} className={`  ${isLang == "en" ? "ltr" : "rtl"}`}>  
                <h2 className="section-title">{t.Naming.title}</h2>
                <ul className={`service-list`}> 
                  <li><strong>{t.Naming.foundationSuccess}:</strong> {t.Naming.foundationSuccessDesc}</li>
                  <li><strong>{t.Naming.globalAppeal}:</strong> {t.Naming.globalAppealDesc}</li>
                  <li><strong>{t.Naming.lastingImpression}:</strong> {t.Naming.lastingImpressionDesc}</li>
                </ul>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
      <ServicesGrid />
      <WhyChooseRightClick />
      <Component.ContactUSHome />
    </div>
  );
};

export default SeoBranding;
